import api from './api';
import types from './mutation-types';

export default {
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setPopupInit_({ commit }) {
		commit(types.POPUP_INIT);
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	setSelectedRow_({ commit }, { key, value }) {
		commit(types.SELECTED_ROW, { key, value });
	},
	setDetailForm_({ commit }, payload) {
		commit(types.DETAIL_FORM, payload);
	},
	setPopupSearchParams_({ commit }, { key, value }) {
		commit(types.POPUP_SEARCH_PARAMS, { key, value });
	},
	async getCommCodes_({ commit }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType);
			if (header.code === 0) {
				const list = [];
				body.length && body.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
				await commit(types.DEFAULT_ASSIGN, { key, value: list });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			throw error.header || error;
		}
	},
	async getPowTourSttsManagements_({ commit, state }) {
		//actions,getters,mutaions는 첫번째 인자로 store안에,commit,state,dispatch
		try {
			const {
				searchParams,
				pagingInfo: { currentPage, pageUnit }
			} = state;

			const data = await api.getPowTourSttsManagements({
				searchParams,
				currentPage,
				pageUnit
			});
			if (data.header.code === 0) {
				commit(types.DEFAULT_ASSIGN, {
					key: 'powTourSttsManagements',
					value: data?.body.resultList || []
				});
				commit(types.DEFAULT_ASSIGN, {
					key: 'pagingInfo',
					value: data?.body.pagingInfo
				});
				commit(types.DEFAULT_ASSIGN, {
					key: 'powTourRgstScrId',
					value: data?.body.powTourRgstScrId
				});
			}
			if (data.header.code === 3) {
			}
			return data?.header;
		} catch (error) {
			throw error.header || error;
		}
	},
	async getOne_({ commit, state }) {
		try {
			const {
				popupSearchParams: { powBttmInfmNo }
			} = state;
			const {
				header,
				body: { resultList, affrList }
			} = await api.getOne({ powBttmInfmNo });
			if (header.code === 0) {
				const value = { ...resultList };
				commit(types.DEFAULT_ASSIGN, { key: 'detailForm', value });
				commit(types.DEFAULT_ASSIGN, { key: 'rmkHistory', value: affrList });
			} else if (header.code === 3) {
				throw new Error(this.getMessage_(header.messageCd));
			}
			return header;
		} catch (error) {
			throw error.header || error;
		}
	},
	async getSearchOne_({ commit, state }) {
		try {
			const {
				popupSearchParams: { powLnCd, insnDd, ipnNos }
			} = state;
			const {
				header,
				body: { resultList, affrList }
			} = await api.getSearchOne({ powLnCd, insnDd, ipnNos });
			if (header.code === 0) {
				const value = { ...resultList };
				commit(types.DEFAULT_ASSIGN, { key: 'detailForm', value });
				commit(types.DEFAULT_ASSIGN, { key: 'rmkHistory', value: affrList });
			} else if (header.code === 3) {
				throw new Error(this.getMessage_(header.messageCd));
			}
			return header;
		} catch (error) {
			throw error.header || error;
		}
	},
	async saveData_(store, data) {
		try {
			const response = await api.saveData(data);
			return response;
		} catch (error) {
			throw error.header || error;
		}
	},
	async updateData_(store, data) {
		try {
			const response = await api.updateData(data);
			return response;
		} catch (error) {
			throw error.header || error;
		}
	},
	async deleteData_(store, data) {
		try {
			const { header } = await api.deleteData(data);
			return header;
		} catch (error) {
			throw error.header || error;
		}
	},
	async fileDownload_(store, params = { fileId, fileSeq }) {
		try {
			const response = await api.fileDownload(params);
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			const filename = decodeURIComponent(response.headers.filename);
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			throw error.header || error;
		}
	},
	async imgDownload_(store, params = { fileId, fileSeq }) {
		try {
			const response = await api.fileDownload(params);
			const filename = decodeURIComponent(response.headers.filename);
			const filetype = decodeURIComponent(filename.substring(filename.lastIndexOf('.') + 1));
			let url = '';
			if ('|JPG|PNG|GIF|'.indexOf(filetype.toUpperCase()) > -1)
				url = window.URL.createObjectURL(new Blob([response.data], { type: 'image/png' }));
			return { name: filename, url };
		} catch (error) {
			throw error.header || error;
		}
	}
};
